import React, { ChangeEvent, Dispatch, SetStateAction } from "react";
import { Autocomplete, TextField } from "@mui/material";

interface IAutocompleteStatusField {
  setIsLoading?: Dispatch<SetStateAction<boolean>>;
  handelOnChangeStatus: (event: ChangeEvent<any>, value: any) => void;
  currentStatus: string | null;
  sx?: React.CSSProperties;
  className?: string;
  isDisabled?: boolean;
  required?: boolean;
  error?: any;
  helperText?: string;
  listLabel?: string;
  placeholder?: string;
}

// Status options: Active, Inactive, All
const statusOptions = ["Active", "Inactive", "All"];

/**
 * Status filter autocomplete with predefined options
 * @returns
 * Selected status value
 */
const AutocompleteStatusField: React.FC<IAutocompleteStatusField> = ({
  setIsLoading,
  handelOnChangeStatus,
  currentStatus,
  sx,
  className,
  isDisabled = false,
  required,
  error,
  helperText,
  listLabel,
  placeholder,
}) => {
  return (
    <Autocomplete
      sx={sx}
      options={statusOptions}
      value={currentStatus || null}
      onChange={(event, value) => handelOnChangeStatus(event, value)}
      renderInput={(params) => (
        <TextField
          style={{ color: "#000000" }}
          {...params}
          label={
            <span>
              {listLabel ? listLabel : "Status"}
              {required ? <span className="required-asterisk">*</span> : ""}
            </span>
          }
          placeholder={placeholder ? placeholder : "Select..."}
          InputLabelProps={{
            shrink: true,
          }}
          error={!!error}
          helperText={helperText || ""}
        />
      )}
      className={className}
      disabled={Boolean(isDisabled)}
    />
  );
};

export default AutocompleteStatusField;

